export const SET_TEAMS = "SET_TEAMS";
export const EDIT_TEAM = "EDIT_TEAM";
export const DELETE_TEAM = "DELETE_TEAM";
